import React, { useState } from 'react'
import styled, { css } from 'styled-components'
import { Collapse, NavLink } from 'reactstrap'

import { Link } from 'react-router-dom'
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
// import { faCog, faHome, faLock } from '@fortawesome/free-solid-svg-icons'
import { ReactComponent as Dashboard } from '../images/NavIcons/dashboard.svg'
import DashboardSelected from '../images/NavIcons/dashboardSelected.svg'

import { ReactComponent as Services } from '../images/NavIcons/services.svg'
import ServicesSelected from '../images/NavIcons/servicesSelected.svg'

import { ReactComponent as Alerts } from '../images/NavIcons/alerts.svg'
import AlertsSelected from '../images/NavIcons/alertsSelected.svg'

import { ReactComponent as Reports } from '../images/NavIcons/reports.svg'
import ReportsSelected from '../images/NavIcons/reportsSelected.svg'

import { ReactComponent as Settings } from '../images/NavIcons/settings.svg'
import SettingsSelected from '../images/NavIcons/settingsSelected.svg'

import Logo from '../images/NavIcons/logo.svg'
import { ReactComponent as DropdownIconClosed } from '../images/dropdownIconClosed.svg'

const StyledNavLink = styled(NavLink)`
  display: flex;
  align-items: center;
  width: 100%;
  margin-left: 5px;
`

const CollapsedLink = styled(NavLink)`
  color: ${({ theme }) => theme.colors.gray4};

  transition: color 0.3s ease;
  :hover {
    color: ${({ theme }) => theme.colors.white};
  }
`

const NavText = styled.div`
  color: ${({ theme }) => theme.colors.gray4};

  opacity: 0;
  width: 0;
  transition: opacity 0.36s ease, color 0.3s ease;
  margin-left: 10px;
`

const Wrapper = styled.div`
  overflow: hidden;
  position: fixed;
  z-index: 1000;
  width: 64px;
  height: 100%;
  inset: 0;
  border-radius: 0 30px 30px 0;
  background: #101621;
  box-shadow: 0 0 20px rgba(17, 26, 38, 0.3);
  transition: width 0.35s ease;

  :hover {
    width: 180px;

    ${NavText} {
      opacity: 1;
    }
    .arrow-toggle {
      opacity: 1;
    }
  }
`

const StyledLogo = styled.div`
  position: absolute;
  top: 20px;
  left: 15px;
`

const LeftLine = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  width: 3px;
  height: 100%;
  background-color: white;
  border-radius: 0 30px 30px 0;
`

const NavItemContainer = styled.div<{
  isActive?: boolean
  securityDropdownOpen?: boolean
}>`
  svg.arrow-toggle {
    opacity: 0;
    pointer-events: none;
    position: absolute;
    top: 17px;
    right: 20px;
    width: 15px;
    height: 15px;

    transform: ${({ securityDropdownOpen }) =>
      securityDropdownOpen ? 'rotate(180deg)' : 'rotate(0)'};

    transition: transform 0.3s ease, opacity 300ms ease;

    path {
      fill: ${({ securityDropdownOpen, theme }) =>
        securityDropdownOpen && theme.colors.white};
    }
  }

  position: relative;
  display: flex;
  align-items: center;
  height: 50px;
  width: inherit;

  ${({ isActive }) =>
    isActive &&
    css`
      background-color: rgb(144, 147, 161, 0.15);
    `};

  ${NavText} {
    color: ${({ theme, isActive }) => isActive && theme.colors.white};
  }

  img {
    width: 20px;
    height: 20px;
  }

  svg {
    path {
      transition: all 0.3s ease;
    }
  }

  :hover {
    svg {
      path {
        fill: ${({ theme }) => theme.colors.white};
      }
    }
    ${NavText} {
      color: ${({ theme }) => theme.colors.white};
    }
  }

  .selected,
  ${LeftLine} {
    display: ${({ isActive }) => (isActive ? 'inline' : 'none')};
  }

  .main {
    display: ${({ isActive }) => (isActive ? 'none' : 'inline')};
  }
`
const NavItems = styled.div`
  position: absolute;
  top: 90px;
  width: 100%;
`

const NavBar: React.FC = () => {
  const [securityDropdownOpen, setSecurityDropdownOpen] = useState(false)
  const [isActive, setIsActive] = useState(0)
  const [isMouseOver, setIsMouseOver] = useState(false)

  const toggleSecurity = () =>
    setSecurityDropdownOpen(!securityDropdownOpen)

  // const [
  //   configurationDropdownOpen,
  //   setConfigurationDropdownOpen,
  // ] = useState(false)
  //
  // const toggleConfiguration = () =>
  //   setConfigurationDropdownOpen(!configurationDropdownOpen)

  return (
    <Wrapper
      id="NavBar"
      onMouseOver={() => setIsMouseOver(true)}
      onMouseLeave={() => setIsMouseOver(false)}
    >
      <StyledLogo>
        <img src={Logo} alt="icon" />
      </StyledLogo>
      <NavItems>
        <NavItemContainer isActive={isActive === 0}>
          <StyledNavLink
            tag={Link}
            exact
            to={'/'}
            onClick={() => setIsActive(0)}
          >
            <Dashboard className="main" />
            <img className="selected" src={DashboardSelected} alt="icon" />
            <NavText>Dashboard</NavText>

            <LeftLine />
          </StyledNavLink>
        </NavItemContainer>

        <NavItemContainer
          isActive={isActive === 1}
          securityDropdownOpen={securityDropdownOpen}
        >
          <StyledNavLink
            tag={Link}
            onClick={() => {
              setIsActive(1)
              toggleSecurity()
            }}
          >
            <Services className="main" />
            <img className="selected" src={ServicesSelected} alt="icon" />
            <NavText>Services</NavText>
            <LeftLine />
          </StyledNavLink>
          <DropdownIconClosed className={'arrow-toggle'} />
        </NavItemContainer>

        <Collapse isOpen={securityDropdownOpen && isMouseOver}>
          <CollapsedLink tag={Link} to="/incidents">
            Incidents
          </CollapsedLink>

          <CollapsedLink tag={Link} to="/indicators">
            Indicators
          </CollapsedLink>

          <CollapsedLink tag={Link} to="/events">
            Events
          </CollapsedLink>
        </Collapse>

        <NavItemContainer isActive={isActive === 2}>
          <StyledNavLink
            tag={Link}
            to={'/'}
            onClick={() => setIsActive(2)}
          >
            <Alerts className="main" />
            <img className="selected" src={AlertsSelected} alt="icon" />
            <NavText>Alerts</NavText>
            <LeftLine />
          </StyledNavLink>
        </NavItemContainer>

        <NavItemContainer isActive={isActive === 3}>
          <StyledNavLink
            tag={Link}
            to={'/'}
            onClick={() => setIsActive(3)}
          >
            <Reports className="main" />
            <img className="selected" src={ReportsSelected} alt="icon" />
            <NavText>Reports</NavText>
            <LeftLine />
          </StyledNavLink>
        </NavItemContainer>

        <NavItemContainer isActive={isActive === 4}>
          <StyledNavLink
            tag={Link}
            to={'/settings'}
            onClick={() => setIsActive(4)}
          >
            <Settings className="main" />
            <img className="selected" src={SettingsSelected} alt="icon" />
            <NavText>Settings</NavText>
            <LeftLine />
          </StyledNavLink>
        </NavItemContainer>
      </NavItems>
    </Wrapper>
  )
}

// const NavBar: React.FC = () => {
//   const [securityDropdownOpen, setSecurityDropdownOpen] = useState(false)
//
//   const toggleSecurity = () =>
//     setSecurityDropdownOpen(!securityDropdownOpen)
//
//   const [
//     configurationDropdownOpen,
//     setConfigurationDropdownOpen,
//   ] = useState(false)
//
//   const toggleConfiguration = () =>
//     setConfigurationDropdownOpen(!configurationDropdownOpen)
//
//   return (
//     <Wrapper>
//       <NavItem>
//         <NavLink tag={Link} to="/">
//           <FontAwesomeIcon icon={faHome} className="mr-2" />
//           Dashboard
//         </NavLink>
//       </NavItem>
//       <NavItem style={{ cursor: 'pointer' }} onClick={toggleSecurity}>
//         <NavLink>
//           <FontAwesomeIcon icon={faLock} className="mr-2" />
//           Security
//         </NavLink>
//       </NavItem>
//
//       <Collapse isOpen={securityDropdownOpen}>
//         <NavItem className="pl-4">
//           <NavLink tag={Link} to="/incidents">
//             Incidents
//           </NavLink>
//         </NavItem>
//         <NavItem className="pl-4">
//           <NavLink tag={Link} to="/indicators">
//             Indicators
//           </NavLink>
//         </NavItem>
//         <NavItem className="pl-4">
//           <NavLink tag={Link} to="/events">
//             Events
//           </NavLink>
//         </NavItem>
//       </Collapse>
//       <NavItem style={{ cursor: 'pointer' }} onClick={toggleConfiguration}>
//         <NavLink>
//           <FontAwesomeIcon icon={faCog} className="mr-2" />
//           Cofiguration
//         </NavLink>
//       </NavItem>
//       <Collapse isOpen={configurationDropdownOpen}>
//         <NavItem className="pl-4">
//           <NavLink tag={Link} to="/settings">
//             Settings
//           </NavLink>
//         </NavItem>
//       </Collapse>
//     </Wrapper>
//   )
// }

export default NavBar
